module.exports = __webpack_public_path__ + "img/granary2.d9d0c62f.png";